// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3UR3d","content":"styles_content__viRpZ","selectAll":"styles_selectAll__1PmZc"};